module.exports = __webpack_public_path__ + "img/purchase_bkg.72098e1e.png";